const _tableImport = {
    excleHead: [
        // status
        {
            title: "Status Import",
            dataIndex: "status_import",
            scopedSlots: { customRender: "status_import" },
            width: 100,
            // fixed: "left",
            className: "center-colum column-header-fix-data-s",
        },
        // status
        {
            title: "Status Import Detail",
            dataIndex: "status_detail",
            scopedSlots: { customRender: "status_detail" },
            width: 150,
            // fixed: "left",
        // className: "center-colum column-header-fix-data-s",
        },
        {
            title: "MUICAA Member",
            dataIndex: "membership_id",
            key: "membership_id",
            width: 80,
            // fixed: "left",
            className: "center-colum column-header-fix-data",
        },
        {
            title: "MUICAA Steering Committee",
            dataIndex: "muicaa_member",
            key: "muicaa_member",
            width: 100,
            // fixed: "left",
            className: "center-colum column-header-fix-data",
        },
        {
            title: "Student_ID",
            dataIndex: "student_id",
            key: "student_id",
            width: 80,
            // fixed: "left",
            className: "center-colum column-header-fix-data",
        },
        {
            title: "Name",
            dataIndex: "Name",
            scopedSlots: { customRender: "Name" },
            width: 200,
            // fixed: "left",
            className: "center-colum column-header-fix-data",
        },
        {
            title: "Former Name",
            scopedSlots: { customRender: "former_name" },
            dataIndex: "former_name",
            className:"center-colum column-header-fix-data-sub",
            width: 200,
        },
        {
            title: "Nationality",
            scopedSlots: { customRender: "Nationality" },
            dataIndex: "Nationality",
            className:"center-colum column-header-fix-data-sub",
            width: 200,
        },
        {
            title: "Major",
            scopedSlots: { customRender: "Major" },
            dataIndex: "Major",
            className:"center-colum column-header-fix-data-sub",
            width: 100,
        },
        {
            title: "Minor",
            dataIndex: "minor",
            key: "minor",
            className:"center-colum column-header-fix-data-sub"
            ,  width: 100,
        },
        {
            title: "Concentration",
            dataIndex: "concentration",
            key: "concentration",
            className:"center-colum column-header-fix-data-sub"
            ,width: 100,
        },
        {
            title: "Grade",
            dataIndex: "grade",
            key: "grade",
            className:"center-colum column-header-fix-data-sub"
            ,width: 100,
        },
        {
            title: "Graduate Status",
            dataIndex: "graduate_status_remark",
            key: "graduate_status_remark",
            className:"center-colum column-header-fix-data-sub"
            ,width: 100,
        },
        {
            title: "Graduate Year",
            dataIndex: "graduate_year",
            key: "graduate_year",
            className:"center-colum column-header-fix-data-sub"
            ,width: 100,
        },
        {
            title: "Graduate Date",
            dataIndex: "graduate_date",
            key: "graduate_date",
            className:"center-colum column-header-fix-data-sub"
            ,width: 100,
        },
        {
            title: "Home Phone",
            dataIndex: "phone_home",
            scopedSlots: { customRender: "phone_home" },
            className:"center-colum column-header-fix-data-sub"
            ,width: 100,
        },
        {
            title: "Mobile Phone",
            dataIndex: "phone_number",
            scopedSlots: { customRender: "phone_number" },
            className:"center-colum column-header-fix-data-sub"
            ,width: 100,
        },
        {
            title: "Email",
            dataIndex: "email",
            scopedSlots: { customRender: "email" },
            className:"center-colum column-header-fix-data-sub"
            ,width: 100,
        },
        {
            title: "Address",
            dataIndex: "address",
            scopedSlots: { customRender: "address" },
            className:"center-colum column-header-fix-data-sub"
            ,width: 200,
        },


        {
            title: "Former Home Phone",
            dataIndex: "former_phone_home",
            scopedSlots: { customRender: "former_phone_home" },
            className:"center-colum column-header-fix-data-sub"
            ,width: 100,
        },
        {
            title: "Former Mobile Phone",
            dataIndex: "former_phone_number",
            scopedSlots: { customRender: "former_phone_number" },
            className:"center-colum column-header-fix-data-sub"
            ,width: 100,
        },
        {
            title: "Former Email",
            dataIndex: "former_email",
            scopedSlots: { customRender: "former_email" },
            className:"center-colum column-header-fix-data-sub"
            ,width: 100,
        },
        {
            title: "Former Address",
            dataIndex: "former_address",
            scopedSlots: { customRender: "former_address" },
            className:"center-colum column-header-fix-data-sub"
            ,width: 200,
        },
    ],
}

export default _tableImport;